<template>
  <div class="activeFailShow">
    <div class="title"></div>
    <div class="time">
      活动时间：3月3日-5月31日
    </div>
    <div class="changebox">
      <active-bag v-if="show" @handler="handler"></active-bag>
      <active-received v-else :bgshow="bgshow"></active-received>
    </div>
  </div>
</template>
<script>
import ActiveBag from "../activebag/index.vue";
import ActiveReceived from "../activereceived/index.vue";
import { commonDialog } from "@/utils/lib/toast";
import { closewxpage } from "@/utils/lib/wxpay";
// import "@/utils/rem.js";

export default {
  data() {
    return {
      show: true,
      bgshow: true,
    };
  },
  components: {
    ActiveBag,
    ActiveReceived,
  },
  methods: {
    handler() {
      let reqBody = {
        code: this.$route.query.code,
        state: this.$route.query.state,
      };
      console.log(reqBody);
      this.$http.reqPostReceiveWelfare(reqBody).then((res) => {
        console.log("领取账号返回======", res);
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            // if (res.item.received) {
            //   this.$router.push("/");
            //   //   this.show = false;
            // } else {
            this.show = false;
            this.bgshow = res.item.received;
            // }
          } else {
            commonDialog(
              res.rltdesc + "，请退出后重新扫码进入。",
              this,
              "确认",
              closewxpage
            );
          }
        } else {
          console.log("领取账号返回出错======", res.rtndesc);
        }
      });
    },
  },
};
</script>
<style lang="less" scope>
.activeFailShow {
  width: 100%;
  height: 100%;
  min-height: 668px;
  background: #da0e3c url(../../../assets/active/img-bj@3x.png) no-repeat;
  background-size: 100%;
  padding: 34px 0 50px 0;
  .title {
    width: calc(100% - 36px);
    height: 79px;
    margin: 0 18px;
    background: url(../../../assets/active/img-title@3x.png) no-repeat;
    background-size: contain;
  }
  .time {
    width: 220px;
    height: 26px;
    margin: 20px 0 0 50%;
    transform: translateX(-50%);
    border: 1px solid #fbceac;
    border-radius: 13px;
    text-align: center;
    color: #fefefe;
    line-height: 27px;
    background: linear-gradient(90deg, #f82f6e, #f73d3a);
  }
  .changebox {
    margin-top: 15px;
  }
}
@keyframes active {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
